import request from '../api';
// 查询数字人列表
export function describeSmallSampleImage(data) {
  return request.post('/app/virtualManTencent/getAppVirtualManTencentPage', data);
}

export function get3DAnchor(data) {
  return request.post('/app/virtualManApi/asset/getAnchor', data);
}

// 查询音色列表
export function describeTimbre(data) {
  return request.post('/app/timbre/getAppTimbrePage', data);
}

// 音频制作接口
export function generateAudio(data) {
  return request.post('/app/make/tts', data);
}

// 视频制作接口
export function generateVideo(data) {
  return request.post('/app/virtualManApi/video/videoMakeAdvanced', data);
}

// 创建视频
export function createVideo(data) {
  return request.post('/app/video/createVideo', data);
}

// 音视频进度查询
export function getProgress(data) {
  return request.post('/app/make/getProgress', data);
}

// 获取制作视频
export function getAppVideoPage(data) {
  return request.post('/app/video/getAppVideoPage', data);
}

// 登录
export function accountLogin(data) {
  return request.post('/app/accountLogin', data);
}

// 获取用户信息
export function getLoginUserInfo() {
  return request.post('/app/getLoginUserInfo', {});
}

// 获取视频详情
export function getAppVideoDetail(id) {
  return request.post(`/app/video/getAppVideo/${id}`, {});
}

// 修改视频
export function updateVideo(data) {
  return request.post(`/app/video/updateVideo`, data);
}

// APP合并视频
export function mergeVideo(data) {
  return request.post(`/app/video/mergeVideo`, data);
}

// 修改视频
export function updateVideoName(data) {
  return request.post(`/app/video/updateVideoName`, data);
}

// 获取平台资源库
export function getAppPlatformResourceLibraryPage(data) {
  return request.post(`/app/platformResourceLibrary/getAppPlatformResourceLibraryPage`, data);
}

// 添加用户资源库
export function addUserResourceLibrary(data) {
  return request.post(`/app/userResourceLibrary/addUserResourceLibrary`, data);
}

// 获取用户资源库
export function getUserResourceLibraryPage(data) {
  return request.post(`/app/userResourceLibrary/getAppUserResourceLibraryPage`, data);
}

// 删除用户资源库
export function deleteUserResourceLibrary(id) {
  return request.post(`/app/userResourceLibrary/deleteUserResourceLibrary/${id}`, {});
}
// ai-chat
export function chatAI(word) {
  return request.post(`/app/ai/chat/chat?word=${word}`, {});
}

// 修改视频名称
export function updateLiveRoom(data) {
  return request.post(`/app/liveRoom/updateLiveRoom`, data);
}

// 删除视频
export function deleteVideo(videoId) {
  return request.post(`/app/video/deleteVideo/${videoId}`, {});
}

// 删除音频
export function deleteAudio(id) {
  return request.post(`/app/sound/deleteSound/${id}`, {});
}

//查询项目
export function queryProject() {
  return request.post(`/app/appProject/queryUserProject`);
}

//发送对话
export function chatByProject(data) {
  return request.post(`/app/ai/chat/chatByProject`, data);
}

//添加chat对话历史记录
export function addChatHistoryRecord(data) {
  return request.post(`/app/chatHistoryRecord/addChatHistoryRecord`, data);
}

// 添加用户反馈
export function addUserFeedback(data) {
  return request.post(`/app/userFeedback/addUserFeedback`, data);
}

// 微信登录-二维码
export function getWxMpQrCode(data = {}) {
  // return request.post(`http://www.jkcxkj.cn/api/wx/getWxMpQrCode`,{})
  return request.post(`/wx/getWxMpQrCode`, data);
}
// 检查
export function checkInviteCode(inviteCode) {
  return request.post(`/app/registerInvite/check/${inviteCode}`);
}
// 生成邀请
export function registerInviteCreateInvite() {
  return request.post('/app/registerInvite/createInvite');
}

// 获取微信用户信息
export function getWxAuthInfo(sceneIdStr) {
  // return request.post(`http://www.jkcxkj.cn/api/wx/getWxAuthInfo?sceneIdStr=${sceneIdStr}`,{})
  return request.post(`/wx/getWxAuthInfo?sceneIdStr=${sceneIdStr}`, {});
}

export function getAppVideo(id) {
  return request.post(`/app/video/getAppVideo/${id}`, {});
}

export function createOrder(data) {
  return request.post(`/app/wxPayOrder/createOrder`, data);
}

export function getOrderPayStatus(data) {
  return request.post(`/app/wxPayOrder/getOrderPayStatus`, data);
}

export function getOrderAmountConfig() {
  return request.post(`/app/wxPayOrder/getOrderAmountConfig`, {});
}

export function getAppVirtualManMarketPage(data) {
  return request.post('/app/virtualManTencent/getAppVirtualManMarketPage', data);
}

// 获取帮助中心
export function getAppHelpCenterTreeList(data?: any) {
  return request.post<any>('/app/helpCenter/getAppHelpCenterTreeList', data);
}

// 获取App用户收藏的数字人分页列表
export function getAppUserCollectVirtualManPage(data?: any) {
  return request.post<any>('/app/userCollect/getAppUserCollectVirtualManPage', data);
}

// 获取App用户收藏的音色分页列表
export function getAppUserCollectTimbrePage(data?: any) {
  return request.post<any>('/app/userCollect/getAppUserCollectTimbrePage', data);
}

// 删除App用户收藏
export function deleteAppUserCollect(data?: any) {
  return request.post<any>('/app/userCollect/deleteAppUserCollect/' + data);
}
// 添加App用户收藏
export function addAppUserCollect(data?: any) {
  return request.post<any>('/app/userCollect/addAppUserCollect', data);
}

// 通过类型删除App用户收藏
export function deleteAppUserCollectByType(data?: any) {
  return request.post<any>('/app/userCollect/deleteAppUserCollectByType', data);
}

// 获取App最近使用的音色
export function getAppRecentUsedTimbreList(data?: any) {
  return request.post<any>('/app/userConsumeRecord/getAppRecentUsedTimbreList', data);
}

// 获取App最近使用的数字人形象;
export function getAppRecentUsedVirtualManList(data?: any) {
  return request.post<any>('/app/userConsumeRecord/getAppRecentUsedVirtualManList', data);
}

// 获取App声音分页列表
export function getAppSoundPage(data) {
  return request.post('/app/sound/getAppSoundPage', data);
}

// 获取音色市场
export function getAppTimbreMarketPage(data) {
  return request.post('/app/timbre/getAppTimbreMarketPage', data);
}

// 生成标题
export function chatCreateTitle(data) {
  return request.post('/app/ai/chat/createTitle', data);
}

// 获取用户消息
export function messageGetUserMessage(data) {
  return request.post('/app/message/getUserMessage', data);
}

// 获取用户消息数量
export function messageUserMessageCount() {
  return request.post('/app/message/userMessageCount');
}

// 修改为已读
export function messageMarkRead(pcId) {
  return request.get(`/app/message/markRead/${pcId}`);
}
// 保存音色
/* export function updateVideo(data) {
  return request.post(`/app/video/updateVideo`, data);
} */

// 获取团队ai记录历史
export function getAppChatHistoryRecordPage(data) {
  return request.post('/app/chatHistoryRecord/getAppChatHistoryRecordPage', data);
}

// 获取交互数字人
export function getAppInteractiveList(data = {}) {
  return request.post('/app/interact/getAppInteractiveList', data);
}
// APP创建视频-新
export function videoNewCreateVideo(data) {
  return request.post('/app/video/newCreateVideo', data);
}

// 创建直播节目
export function addAppLiveProgram(data) {
  return request.post('/app/liveProgram/addAppLiveProgram', data);
}

// 修改直播节目
export function updateAppLiveProgram(data) {
  return request.post('/app/liveProgram/updateAppLiveProgram', data);
}

// 删除直播节目
export function deleteAppLiveProgram(id) {
  return request.post(`/app/liveProgram/deleteAppLiveProgram/${id}`, {});
}

// 获取App积分记录分页列表
export function getAppPointHistoryPage(data) {
  return request.post(`/app/pointHistory/getAppPointHistoryPage`, data);
}

// 获取语言
export function getLanguages(data) {
  return request.get(`/app/dubbing/getLanguages`, data);
}

// 接受邀请
export function acceptInviteInviteId(inviteId) {
  return request.post(`/app/cardBag/acceptInvite/${inviteId}`);
}

// 团队资素材
export function getTeamMedia(data) {
  return request.post('/app/multiMedia/getTeamMedia', data);
}

// 获取分类
export function getCategories(data) {
  return request.post('/app/liveProgramCategory/getAppLiveProgramCategoryPage', data);
}

// 添加分类
export function addProgramCategories(data) {
  return request.post('/app/liveProgramCategory/addLiveProgramCategory', data);
}

// 删除分类
export function deleteCategory(id) {
  return request.post(`/app/liveProgramCategory/deleteLiveProgramCategory/${id}`);
}

// 获取通知公告分页列表
export function getAppSysNoticePage(data) {
  return request.post(`/app/sysNotice/getAppSysNoticePage`, data);
}

// App添加直播节目清单
export function addAppLiveProgramInv(data) {
  return request.post(`/app/liveProgram/addAppLiveProgramInv`, data);
}

// 获取App直播节目清单详情
export function getAppLiveProgramInv(id) {
  return request.post(`/app/liveProgram/getAppLiveProgramInv/${id}`);
}
// App修改直播节目清单
export function updateAppLiveProgramInv(data) {
  return request.post(`/app/liveProgram/updateAppLiveProgramInv`, data);
}

// 创建视频计算积分
export function calculatePoint(data) {
  return request.post(`/app/video/calculatePoint`, data);
}

// 文件下载
export function commonDownload(data) {
  return request({
    method: 'post',
    url: `/common/download`,
    data,
    responseType: 'blob',
  });
}

// 用户提现记录
export function getWithdrawList(data) {
  return request.post('/app/dist/withdrawList', data);
}

// 用户分佣记录
export function getProfitList(data) {
  return request.post('/app/dist/profitList', data);
}
// 用户分佣信息
export function getMemberInfo() {
  return request.post('/app/dist/memberInfo');
}

// 用户提现申请
export function distAddWithdraw(data) {
  return request.post('/app/dist/addWithdraw', data);
}
// 添加分佣用户
export function distAddMember(data) {
  return request.post('/app/dist/addMember', data);
}
